const FILTERS_CHECKBOX_SHARED_CLASSES_PREFIX = "filterCheckbox";
const SHOP_FILTER_CLASSES_PREFIX = "shopFilter";

export const FILTERS_CHECKBOX_SHARED_CLASSES = {
  formControlRoot: `${FILTERS_CHECKBOX_SHARED_CLASSES_PREFIX}-formControlRoot`,
  formControlLabel: `${FILTERS_CHECKBOX_SHARED_CLASSES_PREFIX}-formControlLabel`,
  filterItemLabel: `${FILTERS_CHECKBOX_SHARED_CLASSES_PREFIX}-filterItemLabel`,
  colorFilterCheckbox: `${FILTERS_CHECKBOX_SHARED_CLASSES_PREFIX}-colorFilterCheckbox`,
  colorFilterCheckboxChecked: `${FILTERS_CHECKBOX_SHARED_CLASSES_PREFIX}-colorFilterCheckboxChecked`,
  whiteCheckbox: `${FILTERS_CHECKBOX_SHARED_CLASSES_PREFIX}-whiteCheckbox`,
  checkBox: `${FILTERS_CHECKBOX_SHARED_CLASSES_PREFIX}-checkBox`,
  selectedCategory: `${FILTERS_CHECKBOX_SHARED_CLASSES_PREFIX}-selectedCategory`,
  numberOfItems: `${FILTERS_CHECKBOX_SHARED_CLASSES_PREFIX}-numberOfItems`,
};

export const SHOP_FILTER_CLASSES = {
  filterItemShop: `${SHOP_FILTER_CLASSES_PREFIX}-filterItemShop`,
  shopFilterCheckbox: `${SHOP_FILTER_CLASSES_PREFIX}-shopFilterCheckbox`,
  editButton: `${SHOP_FILTER_CLASSES_PREFIX}-editButton`,
  storeAddressCity: `${SHOP_FILTER_CLASSES_PREFIX}-storeAddressCity`,
  storeAddress: `${SHOP_FILTER_CLASSES_PREFIX}-storeAddress`,
  productFilter: `${SHOP_FILTER_CLASSES_PREFIX}-productFilter`,
  tooltip: `${SHOP_FILTER_CLASSES_PREFIX}-tooltip`,
  tooltipIsCC: `${SHOP_FILTER_CLASSES_PREFIX}-tooltipIsCC`,
  tooltipNotCC: `${SHOP_FILTER_CLASSES_PREFIX}-tooltipNotCC`,
  arrow: `${SHOP_FILTER_CLASSES_PREFIX}-arrow`,
  productFilterTag: `${SHOP_FILTER_CLASSES_PREFIX}-productFilterTag`,
  productFilterSelect: `${SHOP_FILTER_CLASSES_PREFIX}-productFilterSelect`,
  productWithoutClickAndCollect: `${SHOP_FILTER_CLASSES_PREFIX}-productWithoutClickAndCollect`,
  productWithoutClickAndCollectText: `${SHOP_FILTER_CLASSES_PREFIX}-productWithoutClickAndCollectText`,
};
